/* import __COLOCATED_TEMPLATE__ from './appointments-banner.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
var BANNER_TYPE = /*#__PURE__*/function (BANNER_TYPE) {
  BANNER_TYPE["HEADER"] = "HEADER";
  BANNER_TYPE["FOOTER"] = "FOOTER";
  return BANNER_TYPE;
}(BANNER_TYPE || {});
export const CUSTOM_PLAN_THRESHOLD = {
  AU: '$250,000',
  CA: '$250,000',
  ES: '100.000 €',
  FR: '100 000 €',
  GB: '£200,000',
  IE: '€100,000',
  JP: '¥2500万',
  US: '$250,000'
};

/**
 * AppointmentsBanner Component
 *
 * This component displays stylized informational banners with a CTA, used variously
 * within the appointments upsell components.
 */
let AppointmentsBannerComponent = (_class = class AppointmentsBannerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor2, this);
  }
  get type() {
    return this.args.type ?? BANNER_TYPE.HEADER;
  }
  get isHeader() {
    return this.type === BANNER_TYPE.HEADER;
  }
  get isFooter() {
    return this.type === BANNER_TYPE.FOOTER;
  }
  get bannerTitle() {
    if (this.args.title) {
      return this.args.title;
    }
    if (this.isHeader) {
      return this.intl.t('apptsUpsell.comparePlans.header.title');
    }
    if (this.isFooter) {
      return this.intl.t('apptsUpsell.comparePlans.footer.title');
    }
    return '';
  }
  get bannerSubtitle() {
    if (this.args.subtitle) {
      return this.args.subtitle;
    }
    if (this.isHeader && this.appointmentsSubscription.countryCode) {
      return this.intl.t('apptsUpsell.comparePlans.header.subtitle', {
        amountOfMoney: CUSTOM_PLAN_THRESHOLD[this.appointmentsSubscription.countryCode]
      });
    }
    if (this.isFooter && this.appointmentsSubscription.countryCode) {
      return this.intl.t('apptsUpsell.comparePlans.footer.subtitle', {
        amountOfMoney: CUSTOM_PLAN_THRESHOLD[this.appointmentsSubscription.countryCode]
      });
    }
    return '';
  }
  get buttonText() {
    return this.args.buttonText ?? this.intl.t('apptsUpsell.common.contactSales');
  }
  onButtonClick() {
    this.args.onClick?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onButtonClick"), _class.prototype), _class);
export { AppointmentsBannerComponent as default };